export enum actionTypesHubspot {
  ListOfCompanies = "companiesList",
  LoadingFilterCompanies = "LoadingFilterCompanies",
  FilterCompanies = "filteredCompaniesList",
  SearchCompanies = "searchCompaniesList",
  IsCompaniesTableRefreshed = "IsCompaniesTableRefreshed",
  SelectedCompany = "SelectedCompany",
}
